export const selectDataLocator = {
    select_dropdown_testid: 'select_dropdown'
};
